module.exports = __webpack_public_path__ + "static/media/logo.e01d184a.png";